"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RUNNIT_NODE_RUN_MODE = exports.RUNNIT_NODE_RUN_STATE = exports.RUNNIT_NODE_RUN_RESULT_TYPE = exports.UPLOAD_FILE_TYPE = exports.RUNNIT_NODE_DEF_FIELD_MAP_BUILDER_VALUE_TYPE = exports.RUNNIT_NODE_DEF_FIELD_MAP_TYPE = exports.RUNNIT_NODE_FIELD_TYPE = exports.RUNNIT_TYPE = exports.RUNNITS_ACCESS_LEVEL = exports.MODEL_ARCHITECTURE = exports.MODEL_TYPE = exports.MODEL_CREATE_METHOD = exports.SURVEY_KEY = exports.COMPANY_USER_ROLE_PERMISSION_DATA = exports.MANAGE_COMPANY_PERMISSION_LABEL = exports.COMPANY_USER_ROLE_PERMISSION_GROUP_LABEL = exports.COMPANY_USER_ROLE_PERMISSION_GROUP = exports.COMPANY_USER_ROLE_PERMISSION_NON_QUALIFYING_PLAN_DEFAULT = exports.COMPANY_USER_ROLE_PERMISSION_PASSING_VAL = exports.COMPANY_USER_ROLE_PERMISSION = exports.TOKEN_COOLDOWN_TIME_BUCKET_SECONDS = exports.TOKEN_COOLDOWN_TIME_BUCKET = exports.TEAM_USER_ROLE_PERMISSION_DATA = exports.SHARE_RUNNIT_ASSETS_PERMISSION_LABEL = exports.MANAGE_TEAM_MEMBERS_PERMISSION_LABEL = exports.RD_ADMIN_PERMISSION_LABEL = exports.TEAM_USER_ROLE_PERMISSION_GROUP_LABEL = exports.TEAM_USER_ROLE_PERMISSION_GROUP = exports.TEAM_USER_ROLE_PERMISSION_NON_QUALIFYING_PLAN_DEFAULT = exports.TEAM_USER_ROLE_PERMISSION_PASSING_VAL = exports.TEAM_USER_ROLE_PERMISSION = exports.PLUGIN_KIND_LABEL = exports.PLUGIN_KIND_WILDCARD = exports.PLUGIN_KIND = exports.API_SERVICE_SECRET_TYPE = exports.APP_OFFER_RESOURCE_TYPE = exports.APP_OFFER_TYPE = exports.RELEASE_STATUS = exports.STORAGE_OPTION = exports.ANNOUNCEMENT_TYPE = exports.SESSION_BACKGROUND_TASK_STATUS = exports.SESSION_BACKGROUND_TASK_TYPE = exports.STOP_CODE = exports.SESSION_TYPE = exports.SESSION_STATE = exports.SOFTWARE_KEY = exports.HARDWARE_KEY = exports.APP_KEY = exports.CLUB_KEY = exports.CLUB_OFFER_TYPE = void 0;
exports.PROMPT_MAGIC_MODE = exports.NSFW_THRESHOLD = exports.RUNNIT_NODE_DEF_TOOL_APP_TYPE = exports.MODEL_BASE_NODE_DEF_MAP = exports.MODEL_ARCHITECTURE_CREATE_NODE_DEF_APPENDED_TITLE_MAP = exports.MODEL_ARCHITECTURE_CREATE_NODE_DEF_ID_MAP = exports.MODEL_BASE_NODE_DEF_TYPE = exports.TEAM_ROLE = exports.IMAGE_UPLOAD_MODE = exports.RUNNIT_MASK_USE_CASE = exports.AVATAR_USE_CASE = exports.RUNNIT_NODE_DEF_PRICING_TYPE = exports.RUNNIT_NODE_DEF_PROVIDER = exports.resolveRunnitNodeDefTagIcon = exports.DEFAULT_RUNNIT_NODE_DEF_TAG_ICON = exports.RUNNIT_NODE_DEF_TAG_TYPE_ICON = exports.RUNNIT_NODE_DEF_TAG_TYPE_SORT = exports.READABLE_RUNNIT_NODE_DEF_TAG_TYPE = exports.RUNNIT_NODE_DEF_TAG_TYPE_DESCRIPTION = exports.RUNNIT_NODE_DEF_TAG_TYPE = exports.RUNNIT_NODE_DEF_TOOL_TYPE = exports.RUNNIT_NODE_STATIC_FIELDS_KEY = void 0;
var pluralize = require('pluralize');
exports.CLUB_OFFER_TYPE = {
    USER: 'USER',
    COMPANY: 'COMPANY',
};
exports.CLUB_KEY = {
    // Individual Personal Plans
    CC_001: 'CC-001',
    CC_002: 'CC-002',
    FREE_001: 'FREE-001',
    RUNHOB_001: 'RUNHOB-001',
    RUNPRO_001: 'RUNPRO-001',
    // Company Plans
    COMFREE_001: 'COMFREE-001',
    COMOLD_001: 'COMOLD-001',
    COMPRO_001: 'COMPRO-001',
    COMENT_001: 'COMENT-001',
    COMUNI_001: 'COMUNI-001',
};
exports.APP_KEY = {
    // Active production apps
    FILE_001: 'FILE-001',
    AUTO_001: 'AUTO-001',
    VLAD_001: 'VLAD-001',
    CMFY_001: 'CMFY-001',
    ACFT_001: 'ACFT-001',
    EZSD_001: 'EZSD-001',
    FCUS_001: 'FCUS-001',
    FCUS_API_001: 'FCUS_API-001', // underscore — matches production doc id
    KOYA_001: 'KOYA-001',
    FCFZ_001: 'FCFZ-001',
    FRPK_001: 'FRPK-001',
    FRGE_001: 'FRGE-001',
    FLGM_001: 'FLGM-001',
    ADLB_001: 'ADLB-001',
    OWUI_001: 'OWUI-001',
    SUPR_001: 'SUPR-001',
    STSW_001: 'STSW-001',
    OMOS_001: 'OMOS-001',
    // Legacy / retired
    INVK_001: 'INVK-001',
    LINX_001: 'LINX-001',
    ADUI_001: 'ADUI-001',
    OOBA_001: 'OOBA-001',
    MKYO_001: 'MKYO-001',
    RTMY_001: 'RTMY-001',
    ENFG_001: 'ENFG-001',
    MANI_001: 'MANI-001',
};
exports.HARDWARE_KEY = {
    API_001: 'API-001', // Coreweave (legacy) API
    CPU_001: 'CPU-001', // Coreweave (legacy) CPU
    SM_001: 'SM-001', // Coreweave (legacy) Small
    SM_002: 'SM-002', // Coreweave (legacy) Small
    MD_001: 'MD-001', // Coreweave (legacy) Medium
    MD_002: 'MD-002', // Coreweave (legacy) Medium
    MD_003: 'MD-003', // Mobius Medium
    LG_001: 'LG-001', // Coreweave (legacy) Large
    LG_002: 'LG-002', // Coreweave (legacy) Large
    LG_003: 'LG-003', // Mobius Large
    XL_001: 'XL-001', // Coreweave (legacy) Max
    XL_002: 'XL-002', // Coreweave (legacy) Max
    XL_003: 'XL-003', // Mobius Max
    XXL_001: 'XXL-001', // Coreweave (legacy) DoubleMax
    XXL_003: 'XXL-003', // Mobius DoubleMax
};
exports.SOFTWARE_KEY = {
    SD1_001: 'SD1-001',
    SD2_001: 'SD2-001',
    SDXL_001: 'SDXL-001',
    SDALL_001: 'SDALL-001',
    DB_001: 'DB-001',
};
exports.SESSION_STATE = {
    PURCHASE: 'PURCHASE',
    INIT: 'INIT',
    BOOT: 'BOOT',
    READY: 'READY',
    EXTEND: 'EXTEND',
    STOP: 'STOP',
    RECONCILE: 'RECONCILE',
    STOPPED: 'STOPPED',
};
exports.SESSION_TYPE = {
    RD: 'RD',
    SBUD_API: 'SBUD_API',
    INT_API_WORKER: 'INT_API_WORKER',
};
exports.STOP_CODE = {
    MANUAL: 'MANUAL',
    SCHEDULED: 'SCHEDULED',
    FAILED_PURCHASE: 'FAILED_PURCHASE',
    FAILED_INIT: 'FAILED_INIT',
    FAILED_STOP: 'FAILED_STOP',
};
exports.SESSION_BACKGROUND_TASK_TYPE = {
    DOWNLOAD_MODEL: 'DOWNLOAD_MODEL',
    ALERT: 'ALERT',
};
exports.SESSION_BACKGROUND_TASK_STATUS = {
    IN_PROGRESS: 'IN_PROGRESS',
    DONE: 'DONE',
    ERROR: 'ERROR',
    INFO: 'INFO',
    WARNING: 'WARNING',
    DEBUG: 'DEBUG',
};
exports.ANNOUNCEMENT_TYPE = {
    ALERT: 'ALERT',
    WARNING: 'WARNING',
    INFO: 'INFO',
    NEWS: 'NEWS',
    NO_NEW_SESSIONS: 'NO_NEW_SESSIONS',
};
exports.STORAGE_OPTION = {
    PUBLIC: 'PUBLIC',
    PRIVATE: 'PRIVATE',
};
exports.RELEASE_STATUS = {
    OLD: 'OLD',
    CURRENT: 'CURRENT',
    BETA: 'BETA',
};
exports.APP_OFFER_TYPE = {
    IMAGE_GEN: 'IMAGE_GEN',
    IMAGE_TRAIN: 'IMAGE_TRAIN',
    AUDIO: 'AUDIO',
    FILE: 'FILE',
    LLM: 'LLM',
};
exports.APP_OFFER_RESOURCE_TYPE = {
    YOUTUBE: 'YOUTUBE',
    LINK: 'LINK',
};
/**
 * What a `apiServiceSecrets/{id}` document holds.
 *
 * One value today. It exists so the collection can hold a second kind of secret
 * later without every reader having to infer the kind from which fields happen
 * to be populated.
 */
exports.API_SERVICE_SECRET_TYPE = {
    PUBLIC_API_ACCESS_TOKEN: 'PUBLIC_API_ACCESS_TOKEN',
};
// Plugin kind = the wire identifier for one host-app integration. Set on
// `pluginConnectedDevices/{id}.plugin_kind` at device-flow completion and
// read by the auth class when gating per the role's USE_PLUGINS +
// pluginAccessSettings. The string values are part of the public API —
// renaming any one is a breaking change for installed plugins.
//
// Adding a plugin? Its uppercase generate-run value (e.g. 'OMNIVERSE') is
// hardcoded in four more places, and each one needs the new value:
//   - GenerateRunPlugin in shared/src/types/firebase.ts, the type of
//     generateRuns.plugin.
//   - GENERATE_PLUGINS in restServer/apiv2/serializers.py. The v2 Generate API
//     rejects any other `plugin`, and v2 Reporting builds its `surface` filter
//     from it.
//   - The `plugin` choices on GenerateCreateRequestSerializer in
//     restServer/api/serializers.py, which the v1 Generate API enforces.
//   - The "Integrations" model in Metabase: append a (sortOrder, value) row to
//     its VALUES list. It feeds the Integration filter's dropdown on the usage
//     dashboards embedded on the web Reporting page (dashboard IDs in
//     getTeamReportEmbedUrls.ts). The dashboard cards read generateRuns.plugin
//     directly, so they already count the new plugin's usage, but without the
//     model row nobody can select it in the filter.
//     MANUAL STEP: no code or deploy in this repo touches Metabase, so a person
//     has to make this edit in the Metabase UI. Agents: remind the human in the
//     loop to do it before you call the plugin done.
exports.PLUGIN_KIND = {
    PHOTOSHOP: 'photoshop',
    MIRO: 'miro',
    REVIT: 'revit',
    RHINO: 'rhino',
    OMNIVERSE: 'omniverse',
};
// Wildcard sentinel in an account's plugin_kinds list meaning "every plugin
// kind, including ones not yet defined." Surfaced for personal & non-enterprise
// team tiers so a new plugin is granted with no restServer redeploy (ADR-0021).
// The reactive gate + client selectors short-circuit on this instead of
// enumerating PLUGIN_KIND. Mirror of PLUGIN_KIND_WILDCARD in
// restServer/api/auth/permissions.py.
exports.PLUGIN_KIND_WILDCARD = '*';
exports.PLUGIN_KIND_LABEL = {
    photoshop: 'Photoshop',
    miro: 'Miro',
    revit: 'Revit',
    rhino: 'Rhino',
    omniverse: 'Omniverse',
};
exports.TEAM_USER_ROLE_PERMISSION = {
    GENERATE_RUNNIT: 'GENERATE_RUNNIT',
    BATCH_GENERATION: 'BATCH_GENERATION',
    TOKEN_LIMIT: 'TOKEN_LIMIT',
    TOKEN_COOLDOWN: 'TOKEN_COOLDOWN',
    VIEW_TRAIN: 'VIEW_TRAIN',
    SHARE_RUNNIT_ASSETS: 'SHARE_RUNNIT_ASSETS',
    MANAGE_ALL_GENERATIONS: 'MANAGE_ALL_GENERATIONS',
    NUM_RESULTS_LIMIT: 'NUM_RESULTS_LIMIT',
    BLOCK_NODE_DEFS: 'BLOCK_NODE_DEFS',
    USE_PLUGINS: 'USE_PLUGINS',
    RD_ADMIN: 'RD_ADMIN',
    USE_RD: 'USE_RD',
    MANAGE_TEAM_MEMBERS: 'MANAGE_TEAM_MEMBERS',
    SHOW_TOKEN_BALANCE: 'SHOW_TOKEN_BALANCE',
};
exports.TEAM_USER_ROLE_PERMISSION_PASSING_VAL = {
    // Some permissions are blocking/restricting behavior (e.g. token limits), and some are feature flags (e.g. manage team members)
    GENERATE_RUNNIT: true,
    BATCH_GENERATION: true,
    TOKEN_LIMIT: false,
    TOKEN_COOLDOWN: false,
    VIEW_TRAIN: true,
    SHARE_RUNNIT_ASSETS: true,
    MANAGE_ALL_GENERATIONS: true,
    NUM_RESULTS_LIMIT: false,
    BLOCK_NODE_DEFS: false,
    USE_PLUGINS: true, // ON = role may use the plugin kinds listed in pluginAccessSettings.pluginKinds
    RD_ADMIN: true,
    USE_RD: true,
    MANAGE_TEAM_MEMBERS: true,
    SHOW_TOKEN_BALANCE: true,
};
exports.TEAM_USER_ROLE_PERMISSION_NON_QUALIFYING_PLAN_DEFAULT = {
    // Personal & team (non-enterprise) plans use these defaults verbatim. Enterprise plans do NOT use this
    // map — they read each permission straight from the user's team role (granted iff explicitly present).
    GENERATE_RUNNIT: true, // Default allow generation
    BATCH_GENERATION: true, // Default allow batch generation when generation is allowed
    TOKEN_LIMIT: false, // Default no limit on token spending
    TOKEN_COOLDOWN: false, // Default no token cooldown enforcement
    VIEW_TRAIN: true, // Default allow training
    SHARE_RUNNIT_ASSETS: true, // Default allow full control of sharing/access settings
    MANAGE_ALL_GENERATIONS: false, // Default no elevated "see/manage all generations of any user on team" view
    NUM_RESULTS_LIMIT: false, // Default allow "number of generations for a run" selection when generating
    BLOCK_NODE_DEFS: false, // Default no tool/tag blocklists
    USE_PLUGINS: true, // Default allow plugins for personal & non-enterprise teams (ADR-0021). Enterprise ignores
    // this map and defaults USE_PLUGINS to deny unless a role opts in via pluginAccessSettings.
    RD_ADMIN: true, // Default allow admin
    USE_RD: true, // Default allow use of Open-Source Apps platform
    MANAGE_TEAM_MEMBERS: false, // Default no team-level permission for managing team members
    SHOW_TOKEN_BALANCE: true, // Default allow balance visibility
};
exports.TEAM_USER_ROLE_PERMISSION_GROUP = {
    // Note this order is important for the UI, it determines the order of the groups listed on the role permissions page
    TEAM: 'TEAM',
    RUNNIT: 'RUNNIT',
    RD: 'RD',
};
exports.TEAM_USER_ROLE_PERMISSION_GROUP_LABEL = {
    TEAM: 'Team',
    RUNNIT: 'Generation Tools',
    RD: 'Open-Source Apps',
};
exports.RD_ADMIN_PERMISSION_LABEL = 'Can manage Open-Source Apps platform';
exports.MANAGE_TEAM_MEMBERS_PERMISSION_LABEL = `Can manage members`;
exports.SHARE_RUNNIT_ASSETS_PERMISSION_LABEL = `Can manage sharing settings`;
const TEAM_USER_ROLE_PERMISSION_DATA = (displayLabels) => ({
    // Runnit Permissions
    GENERATE_RUNNIT: {
        label: 'Can generate',
        description: 'Allows users to create AI-generated content using Image, Video, and Edit tools. Turn this off to create a "readonly" or "non-creator" role.',
        group: exports.TEAM_USER_ROLE_PERMISSION_GROUP.RUNNIT,
        tags: [
            { label: 'CREATOR+', color: 'success' },
        ],
        supportUrl: 'https://www.rundiffusion.com/rundiffusion-team-roles-permissions#can-generate',
    },
    BATCH_GENERATION: {
        label: 'Can use batch generation',
        description: 'Allows users to run multiple settings variations from one tool in a single workflow.',
        group: exports.TEAM_USER_ROLE_PERMISSION_GROUP.RUNNIT,
        dependsOn: [
            exports.TEAM_USER_ROLE_PERMISSION.GENERATE_RUNNIT
        ],
    },
    TOKEN_LIMIT: {
        label: 'Limit per generation token cost',
        description: 'Control access to expensive tools before users receive proper training. Enforce a maximum token limit when generating, and optionally a different limit per media type (video costs far more than an image). If this is turned off, users can use any tool without token limits. (Tokens spent to train models are not affected using this permission).',
        group: exports.TEAM_USER_ROLE_PERMISSION_GROUP.RUNNIT,
        subFields: ['tokenLimitSettings'],
        dependsOn: [
            exports.TEAM_USER_ROLE_PERMISSION.GENERATE_RUNNIT
        ],
        supportUrl: 'https://www.rundiffusion.com/rundiffusion-team-roles-permissions#limit-per-generation-token-cost',
    },
    NUM_RESULTS_LIMIT: {
        label: 'Limit number of results per run',
        description: 'Depending on the tool, users are able to generate multiple results in a single run. Set a maximum number of images or videos a user can generate at a time (e.g. set to 4 to limit to 1–4 results per run, set to 1 to allow only one at a time).',
        group: exports.TEAM_USER_ROLE_PERMISSION_GROUP.RUNNIT,
        subFields: ['numResultsLimitSettings'],
        dependsOn: [
            exports.TEAM_USER_ROLE_PERMISSION.GENERATE_RUNNIT
        ],
        supportUrl: 'https://www.rundiffusion.com/rundiffusion-team-roles-permissions#limit-number-of-results-per-run',
    },
    BLOCK_NODE_DEFS: {
        label: 'Block specific tools or an entire "Model Family"',
        description: 'Hide and restrict access to specific tools or entire "Model Family" groupings (e.g. Google, ByteDance, Kling).',
        group: exports.TEAM_USER_ROLE_PERMISSION_GROUP.RUNNIT,
        subFields: ['restrictNodeDefTagsSettings'],
        supportUrl: 'https://www.rundiffusion.com/rundiffusion-team-roles-permissions#block-specific-tools-or-an-entire-%E2%80%9Cmodel-family%E2%80%9D',
    },
    USE_PLUGINS: {
        label: 'Allow plugin and API access',
        description: 'Allow users to reach RunDiffusion from outside the web app: through third-party plugins, or directly against the RunDiffusion API.',
        group: exports.TEAM_USER_ROLE_PERMISSION_GROUP.RUNNIT,
        subFields: ['pluginAccessSettings'],
    },
    VIEW_TRAIN: {
        label: 'Can train models',
        description: 'Allows users to create and train custom AI models using the plaform\'s training capabilities.',
        group: exports.TEAM_USER_ROLE_PERMISSION_GROUP.RUNNIT,
        tags: [
            { label: 'CREATOR+', color: 'success' },
        ],
        supportUrl: 'https://www.rundiffusion.com/rundiffusion-team-roles-permissions#can-train-models',
    },
    SHARE_RUNNIT_ASSETS: {
        label: exports.SHARE_RUNNIT_ASSETS_PERMISSION_LABEL,
        description: `Allows users to manage sharing settings for assets they own, including boards and models. Users can share them with everyone on the ${displayLabels.team} or restrict a board to selected members. They can also edit boards and models that other members have shared.`,
        group: exports.TEAM_USER_ROLE_PERMISSION_GROUP.RUNNIT,
        supportUrl: 'https://www.rundiffusion.com/rundiffusion-team-roles-permissions#can-manage-shared-assets',
    },
    MANAGE_ALL_GENERATIONS: {
        label: `Can manage everyone's generations and boards`,
        description: `Enables users to view, edit, and delete any generation or board in the ${displayLabels.team} (including Private boards), and to change any board's owner. Note: Sharing a board (e.g. moving it from Private to Shared) also requires the "${exports.SHARE_RUNNIT_ASSETS_PERMISSION_LABEL}" permission.`,
        group: exports.TEAM_USER_ROLE_PERMISSION_GROUP.RUNNIT,
        supportUrl: 'https://www.rundiffusion.com/rundiffusion-team-roles-permissions#can-manage-everyone%E2%80%99s-generations-and-boards',
    },
    // RD Permissions
    USE_RD: {
        label: 'Can use Open-Source Apps platform',
        description: 'Grants access to view and use the Open-Source Apps platform features and interface.',
        group: exports.TEAM_USER_ROLE_PERMISSION_GROUP.RD,
        supportUrl: 'https://www.rundiffusion.com/rundiffusion-team-roles-permissions#can-use-open-source-apps-platform',
    },
    RD_ADMIN: {
        label: exports.RD_ADMIN_PERMISSION_LABEL,
        description: `Grants access to manage the Open-Source Apps platform for the ${displayLabels.team}. Note: Company administrators with the "${exports.MANAGE_COMPANY_PERMISSION_LABEL}" permission will supersede this permission.`,
        group: exports.TEAM_USER_ROLE_PERMISSION_GROUP.RD,
        dependsOn: [
            exports.TEAM_USER_ROLE_PERMISSION.USE_RD
        ],
        supportUrl: 'https://www.rundiffusion.com/rundiffusion-team-roles-permissions#can-manage-open-source-apps-platform',
    },
    // Team Permissions
    TOKEN_COOLDOWN: {
        label: 'Implement a "Token Cooldown" (e.g. limit user to 10,000 tokens every hour)',
        description: 'Control the rate of spending tokens for a user. This is useful to prevent users from spending too many tokens in a short period of time. This applies to both the Generation Tools and the Open-Source Apps.',
        group: exports.TEAM_USER_ROLE_PERMISSION_GROUP.TEAM,
        subFields: ['tokenCooldownSettings'],
        supportUrl: 'https://www.rundiffusion.com/rundiffusion-team-roles-permissions#implement-a-%E2%80%9Ctoken-cooldown%E2%80%9D',
    },
    SHOW_TOKEN_BALANCE: {
        label: `Show ${displayLabels.team} token balance`,
        description: `Control whether the ${displayLabels.team} token balance is seen by the member. Note: Company administrators with the "${exports.MANAGE_COMPANY_PERMISSION_LABEL}" permission will supersede this permission.`,
        group: exports.TEAM_USER_ROLE_PERMISSION_GROUP.TEAM,
        supportUrl: 'https://www.rundiffusion.com/rundiffusion-team-roles-permissions#show-team-token-balance',
    },
    MANAGE_TEAM_MEMBERS: {
        label: exports.MANAGE_TEAM_MEMBERS_PERMISSION_LABEL,
        description: `Grants access to invite, update, and remove members in the ${displayLabels.team}. Note: Company administrators with the "${getManageTeamsLabel(displayLabels)}" permission will supersede this permission.`,
        group: exports.TEAM_USER_ROLE_PERMISSION_GROUP.TEAM,
        supportUrl: 'https://www.rundiffusion.com/rundiffusion-team-roles-permissions#can-manage-members',
    },
});
exports.TEAM_USER_ROLE_PERMISSION_DATA = TEAM_USER_ROLE_PERMISSION_DATA;
exports.TOKEN_COOLDOWN_TIME_BUCKET = {
    '1min': '1min',
    '2min': '2min',
    '5min': '5min',
    '10min': '10min',
    '15min': '15min',
    '30min': '30min',
    '1hr': '1hr',
    '2hr': '2hr',
    '3hr': '3hr',
    '12hr': '12hr',
    '1day': '1day',
    '3day': '3day',
    '7day': '7day',
    '30day': '30day',
};
exports.TOKEN_COOLDOWN_TIME_BUCKET_SECONDS = {
    '1min': 60, // 1 minute
    '2min': 120, // 2 minutes
    '5min': 300, // 5 minutes
    '10min': 600, // 10 minutes
    '15min': 900, // 15 minutes
    '30min': 1800, // 30 minutes
    '1hr': 3600, // 1 hour
    '2hr': 7200, // 2 hours
    '3hr': 10800, // 3 hours
    '12hr': 43200, // 12 hours
    '1day': 86400, // 1 day
    '3day': 259200, // 3 days
    '7day': 604800, // 7 days
    '30day': 2592000, // 30 days
};
exports.COMPANY_USER_ROLE_PERMISSION = {
    VIEW_COMPANY_REPORTS: 'VIEW_COMPANY_REPORTS',
    MANAGE_COMPANY: 'MANAGE_COMPANY',
    MANAGE_TEAMS: 'MANAGE_TEAMS',
    MANAGE_COMPANY_TEAM_ROLES: 'MANAGE_COMPANY_TEAM_ROLES',
    MANAGE_API_TOKENS: 'MANAGE_API_TOKENS',
};
exports.COMPANY_USER_ROLE_PERMISSION_PASSING_VAL = {
    // Some permissions are blocking/restricting behavior (e.g. token limits), and some are feature flags (e.g. manage team members)
    VIEW_COMPANY_REPORTS: true,
    MANAGE_COMPANY: true,
    MANAGE_TEAMS: true,
    MANAGE_COMPANY_TEAM_ROLES: true,
    MANAGE_API_TOKENS: true,
};
exports.COMPANY_USER_ROLE_PERMISSION_NON_QUALIFYING_PLAN_DEFAULT = {
    // Personal plans use these defaults, team & enterprise plans will read the user's company role permissions
    VIEW_COMPANY_REPORTS: false, // Default no access to company reports
    MANAGE_COMPANY: false, // Default no company management
    MANAGE_TEAMS: false, // Default no team management
    MANAGE_COMPANY_TEAM_ROLES: false, // Default no company admin user management
    MANAGE_API_TOKENS: false, // Default no access to the company API token
};
exports.COMPANY_USER_ROLE_PERMISSION_GROUP = {
    // Note this order is important for the UI, it determines the order of the groups listed on the role permissions page
    COMPANY: 'COMPANY',
};
exports.COMPANY_USER_ROLE_PERMISSION_GROUP_LABEL = {
    COMPANY: 'Company',
};
exports.MANAGE_COMPANY_PERMISSION_LABEL = `Can manage company`;
const getManageTeamsLabel = (displayLabels) => `Can manage ${pluralize(displayLabels.team)} and members`;
const COMPANY_USER_ROLE_PERMISSION_DATA = (displayLabels) => ({
    VIEW_COMPANY_REPORTS: {
        label: 'Can view company reports',
        description: `Grants access to view reports and analytics for every ${displayLabels.team} in the company.`,
        group: exports.COMPANY_USER_ROLE_PERMISSION_GROUP.COMPANY,
        supportUrl: 'https://www.rundiffusion.com/company-roles#can-view-company-reports',
    },
    MANAGE_COMPANY: {
        label: exports.MANAGE_COMPANY_PERMISSION_LABEL,
        description: `Grants access to manage the company and its settings. This includes managing company admin users, company settings, and company budget allocations. Additionally, users with this permission will be notified by email when any ${displayLabels.team} exceeds its monthly budget.`,
        group: exports.COMPANY_USER_ROLE_PERMISSION_GROUP.COMPANY,
        supportUrl: 'https://www.rundiffusion.com/company-roles#can-manage-company',
    },
    MANAGE_COMPANY_TEAM_ROLES: {
        label: `Can manage ${displayLabels.team} role settings`,
        description: `Grants access to create new and edit existing ${displayLabels.team} roles in the company.`,
        group: exports.COMPANY_USER_ROLE_PERMISSION_GROUP.COMPANY,
        supportUrl: 'https://www.rundiffusion.com/company-roles#can-manage-team-role-settings',
    },
    MANAGE_API_TOKENS: {
        label: 'Can manage API access tokens',
        description: 'Grants access to create and delete the company\'s API access tokens.',
        group: exports.COMPANY_USER_ROLE_PERMISSION_GROUP.COMPANY,
        supportUrl: 'https://www.rundiffusion.com/company-roles#can-manage-api-access-tokens',
    },
    MANAGE_TEAMS: {
        label: getManageTeamsLabel(displayLabels),
        description: `Grants access to create, edit, and deactivate any ${displayLabels.team} in the company and manage their members. Note: This permission will supersede the ${displayLabels.team} Role permission called "${exports.MANAGE_TEAM_MEMBERS_PERMISSION_LABEL}".`,
        group: exports.COMPANY_USER_ROLE_PERMISSION_GROUP.COMPANY,
        supportUrl: 'https://www.rundiffusion.com/company-roles#can-manage-teams-and-members',
    },
});
exports.COMPANY_USER_ROLE_PERMISSION_DATA = COMPANY_USER_ROLE_PERMISSION_DATA;
exports.SURVEY_KEY = {
    NEW_USER_1: 'NEW_USER_1',
    NEW_USER_ONBOARDING_1: 'NEW_USER_ONBOARDING_1',
    USER_USAGE_1: 'USER_USAGE_1',
    NEW_TEAM_1: 'NEW_TEAM_1',
};
exports.MODEL_CREATE_METHOD = {
    UPLOAD: 'UPLOAD',
    RUNNIT: 'RUNNIT',
};
exports.MODEL_TYPE = {
    CHECKPOINT: 'CHECKPOINT',
    LORA: 'LORA',
};
exports.MODEL_ARCHITECTURE = {
    FLUX: 'FLUX',
    SDXL: 'SDXL',
};
exports.RUNNITS_ACCESS_LEVEL = {
    PRIVATE: 'PRIVATE',
    SHARED: 'SHARED',
    RESTRICTED: 'RESTRICTED',
};
exports.RUNNIT_TYPE = {
    WORKFLOW: 'WORKFLOW',
    SINGLE_TOOL: 'SINGLE_TOOL',
    TEMPLATE: 'TEMPLATE',
    CANVAS: 'CANVAS',
};
exports.RUNNIT_NODE_FIELD_TYPE = {
    HEADER: 'HEADER',
    HTML: 'HTML',
    TEXT_AREA: 'TEXT_AREA',
    TEXT: 'TEXT',
    NUM: 'NUM',
    BOOLEAN: 'BOOLEAN',
    SINGLE_SELECT: 'SINGLE_SELECT',
    MULTI_SELECT: 'MULTI_SELECT',
    MODEL_SINGLE_SELECT: 'MODEL_SINGLE_SELECT',
    PROMPT: 'PROMPT',
    NEG_PROMPT: 'NEG_PROMPT',
    CFG: 'CFG',
    WIDTH_HEIGHT: 'WIDTH_HEIGHT',
    IMG: 'IMG',
    VIDEO: 'VIDEO',
    ASSET_3D: 'ASSET_3D',
    STEPS: 'STEPS',
    SEED: 'SEED',
    SLIDER: 'SLIDER',
    UPSCALE_FACTOR_SLIDER: 'UPSCALE_FACTOR_SLIDER',
    IMGS: 'IMGS',
};
exports.RUNNIT_NODE_DEF_FIELD_MAP_TYPE = {
    JSON: 'JSON',
    NUM: 'NUM',
    STR: 'STR',
    BOOL: 'BOOL',
    PROMPT: 'PROMPT',
    IMGS: 'IMGS',
    IMG: 'IMG',
    VIDEO: 'VIDEO',
    ASSET_3D: 'ASSET_3D',
    IMG_MASK: 'IMG_MASK',
    MODEL: 'MODEL',
};
exports.RUNNIT_NODE_DEF_FIELD_MAP_BUILDER_VALUE_TYPE = {
    STR_MUSTACHE: 'STR_MUSTACHE',
};
exports.UPLOAD_FILE_TYPE = {
    IMG: 'IMG',
    VID: 'VID',
    ASSET_3D: 'ASSET_3D',
};
exports.RUNNIT_NODE_RUN_RESULT_TYPE = {
    IMG: 'IMG',
    VID: 'VID',
    MODEL: 'MODEL',
    ASSET_3D: 'ASSET_3D',
    LAYERS: 'LAYERS',
    TEXT: 'TEXT',
};
exports.RUNNIT_NODE_RUN_STATE = {
    DRAFT: 'DRAFT',
    INIT: 'INIT',
    NSFW: 'NSFW',
    QUEUED: 'QUEUED',
    ERROR: 'ERROR',
    DONE: 'DONE',
};
exports.RUNNIT_NODE_RUN_MODE = {
    MANUAL: 'MANUAL',
};
exports.RUNNIT_NODE_STATIC_FIELDS_KEY = {
    numResults: 'numResults',
};
exports.RUNNIT_NODE_DEF_TOOL_TYPE = {
    CORE: 'CORE',
    COMPANY: 'COMPANY',
};
exports.RUNNIT_NODE_DEF_TAG_TYPE = {
    HOME_PAGE: 'HOME_PAGE',
    INDUSTRY: 'INDUSTRY',
    USE_CASE: 'USE_CASE',
    MEDIA: 'MEDIA',
    MODEL_FAMILY: 'MODEL_FAMILY',
    TRAINING_TYPE: 'TRAINING_TYPE',
    TRAINING_QUALITY: 'TRAINING_QUALITY',
    INTERNAL: 'INTERNAL',
};
exports.RUNNIT_NODE_DEF_TAG_TYPE_DESCRIPTION = {
    HOME_PAGE: 'Used for the old home page organization',
    INDUSTRY: 'The Industry the tool is used in',
    USE_CASE: 'The use case the tool is used in',
    MEDIA: 'The media type the tool generates',
    MODEL_FAMILY: 'The model family grouping (e.g. Google, ByteDance, Kling)',
    TRAINING_TYPE: 'The type of training the tool underwent',
    TRAINING_QUALITY: 'The quality type that the tool underwent',
    INTERNAL: 'Internal tags for RunDiffusion admins, hidden to other users',
};
exports.READABLE_RUNNIT_NODE_DEF_TAG_TYPE = {
    HOME_PAGE: 'Home Page',
    INDUSTRY: 'Industry',
    USE_CASE: 'Use Case',
    MEDIA: 'Media',
    MODEL_FAMILY: 'Model Family',
    TRAINING_TYPE: 'Training Type',
    TRAINING_QUALITY: 'Training Quality',
    INTERNAL: 'Internal',
};
let runnitNodeDefTagTypeSortIter = 0;
exports.RUNNIT_NODE_DEF_TAG_TYPE_SORT = {
    HOME_PAGE: runnitNodeDefTagTypeSortIter++,
    INDUSTRY: runnitNodeDefTagTypeSortIter++,
    USE_CASE: runnitNodeDefTagTypeSortIter++,
    MEDIA: runnitNodeDefTagTypeSortIter++,
    MODEL_FAMILY: runnitNodeDefTagTypeSortIter++,
    TRAINING_TYPE: runnitNodeDefTagTypeSortIter++,
    TRAINING_QUALITY: runnitNodeDefTagTypeSortIter++,
    INTERNAL: runnitNodeDefTagTypeSortIter++,
};
exports.RUNNIT_NODE_DEF_TAG_TYPE_ICON = {
    HOME_PAGE: 'mdi-home-outline',
    INDUSTRY: 'mdi-domain',
    USE_CASE: 'mdi-folder-table-outline',
    MEDIA: 'mdi-multimedia',
    MODEL_FAMILY: 'mdi-shape-outline',
    TRAINING_TYPE: 'mdi-group',
    TRAINING_QUALITY: 'mdi-group',
    INTERNAL: 'mdi-lock',
};
/** Last-resort icon: the tag has none of its own and its type is unrecognized. */
exports.DEFAULT_RUNNIT_NODE_DEF_TAG_ICON = 'mdi-shape-outline';
/**
 * The mdi icon to render for one tag.
 *
 * Three tiers, most specific first:
 *   1. `tag.icon`, set per tag in `runnitNodeDefTags` (Manage Tool Tags).
 *   2. The icon for the tag's TYPE, so an un-iconed MODEL_FAMILY tag still looks
 *      like a model family rather than like everything else.
 *   3. `DEFAULT_RUNNIT_NODE_DEF_TAG_ICON`.
 *
 * Tier 2 exists because most of the 70-odd tags will never be worth hand-picking
 * an icon for, and falling straight to one generic glyph would flatten the
 * distinction the type icons already draw.
 *
 * Written without `?.` / `??`: web's webpack-4 parser reads the symlinked shared
 * dist without transpiling it. See shared/src/tokenLimits.ts.
 */
const resolveRunnitNodeDefTagIcon = (tag) => {
    if (!tag)
        return exports.DEFAULT_RUNNIT_NODE_DEF_TAG_ICON;
    const own = tag.icon ? tag.icon.trim() : '';
    if (own)
        return own;
    const byType = tag.type ? exports.RUNNIT_NODE_DEF_TAG_TYPE_ICON[tag.type] : '';
    return byType || exports.DEFAULT_RUNNIT_NODE_DEF_TAG_ICON;
};
exports.resolveRunnitNodeDefTagIcon = resolveRunnitNodeDefTagIcon;
exports.RUNNIT_NODE_DEF_PROVIDER = {
    RUNNIT_IMG: 'RUNNIT_IMG',
    RD: 'RD',
    OCTOAI: 'OCTOAI',
    RUNPOD: 'RUNPOD',
    IDEOGRAM: 'IDEOGRAM',
    FALAI: 'FALAI',
    NICHETENSOR: 'NICHETENSOR',
    RUNWAY: 'RUNWAY',
    LUMAAI: 'LUMAAI',
    KLINGAI: 'KLINGAI',
    RUNWARE: 'RUNWARE',
    KIEAI: 'KIEAI',
    OPENAI: 'OPENAI',
    TOPAZ: 'TOPAZ',
    FREEPIK: 'FREEPIK',
    MODAL: 'MODAL',
    VERTEX: 'VERTEX',
};
exports.RUNNIT_NODE_DEF_PRICING_TYPE = {
    COST: 'COST',
    INFERENCE: 'INFERENCE',
};
exports.AVATAR_USE_CASE = {
    RUNNIT: 'RUNNIT',
    RUNNIT_LIB: 'RUNNIT_LIB',
    RUNNIT_NODE_DEF: 'RUNNIT_NODE_DEF',
    MODEL: 'MODEL',
};
exports.RUNNIT_MASK_USE_CASE = {
    INPAINTING: 'INPAINTING',
};
exports.IMAGE_UPLOAD_MODE = {
    RUNNIT_UPLOAD: 'RUNNIT_UPLOAD',
    AVATAR: 'AVATAR',
    MODEL: 'MODEL',
};
exports.TEAM_ROLE = {
    ADMIN: 'ADMIN',
    CREATOR: 'CREATOR',
};
exports.MODEL_BASE_NODE_DEF_TYPE = {
    FLUX_BASE: 'FLUX_BASE',
    FLUX_FILL: 'FLUX_FILL',
    SDXL_BASE: 'SDXL_BASE',
};
exports.MODEL_ARCHITECTURE_CREATE_NODE_DEF_ID_MAP = {
    FLUX_BASE: 'k6uTFLWZ5OBxh7ZGfy4E',
    FLUX_FILL: 'Zo7U5EEzIX7zodh7bwPL',
    SDXL_BASE: 'TowPq1VRuRzLxct4GRNJ',
};
exports.MODEL_ARCHITECTURE_CREATE_NODE_DEF_APPENDED_TITLE_MAP = {
    FLUX_BASE: '(FLUX Image)',
    FLUX_FILL: '(FLUX Inpainting)',
    SDXL_BASE: '(SDXL Image)',
};
exports.MODEL_BASE_NODE_DEF_MAP = {
    FLUX: [
        exports.MODEL_BASE_NODE_DEF_TYPE.FLUX_BASE,
        exports.MODEL_BASE_NODE_DEF_TYPE.FLUX_FILL,
    ],
    SDXL: [
        exports.MODEL_BASE_NODE_DEF_TYPE.SDXL_BASE,
    ],
};
exports.RUNNIT_NODE_DEF_TOOL_APP_TYPE = {
    RUNNIT: 'RUNNIT',
    TRAINER: 'TRAINER',
};
exports.NSFW_THRESHOLD = {
    SFW_1: 'SFW_1',
    SFW_2: 'SFW_2',
    NSFW_1: 'NSFW_1',
    NSFW_2: 'NSFW_2',
};
exports.PROMPT_MAGIC_MODE = {
    AUTO: 'AUTO',
    ON: 'ON',
    OFF: 'OFF',
};
